const selectors = {
  root: ":root",
  header: "[data-header]",
  pageNavigation: "[data-page-nav]",
  pageNavigationLink: "[data-page-nav-link]",
};

const setScrollPadding = (value: number) => {
  const root = document.querySelector(selectors.root) as HTMLElement;

  root.style.setProperty("--scroll-padding-top", value + "px");
};

const initPageNavigation = (pageNavigation: Element) => {
  const header = document.querySelector(selectors.header) as HTMLElement;
  const scrollPadding = header.clientHeight + pageNavigation.clientHeight;

  const pageNavigationLinks = [
    ...pageNavigation.querySelectorAll(selectors.pageNavigationLink),
  ].map((element) => ({
    id: element.hash.slice(1),
    element: element,
  }));

  const observedBlocks = pageNavigationLinks.reduce((acc, link) => {
    const block = document.getElementById(link.id);

    return block ? [...acc, block] : acc;
  }, []);

  const observer = new IntersectionObserver(
    () => {
      const firstVisibleBlock = observedBlocks.find(
        (block) => block.getBoundingClientRect().top >= scrollPadding
      );

      pageNavigationLinks?.forEach((link) =>
        link.element.setAttribute(
          "data-active",
          firstVisibleBlock && link.id === firstVisibleBlock.id
        )
      );
    },
    {
      root: null,
      rootMargin: `-${scrollPadding}px 0px 0px`,
      threshold: [0, 1],
    }
  );

  observedBlocks.forEach((block) => observer.observe(block));
  setScrollPadding(scrollPadding);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const navigations = document.querySelectorAll(selectors.pageNavigation);

    navigations?.forEach(initPageNavigation);
  },
  {
    once: true,
  }
);
